import { render } from "./ShopVouchersPage.vue?vue&type=template&id=3d589c14&scoped=true"
import script from "./ShopVouchersPage.vue?vue&type=script&lang=js"
export * from "./ShopVouchersPage.vue?vue&type=script&lang=js"

import "./ShopVouchersPage.vue?vue&type=style&index=0&id=3d589c14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d589c14"]])

export default __exports__